import CardCommon from '@op/components/CardCommon';
import React, { useMemo } from 'react';
import { useMemeLangDistribution } from '@opm/pages/Memes/hooks';
import useIntls from '@opm/hooks/useIntls';
import DistributionProgress from '../DistributionProgress';
import { dealWithOthersName } from '@op/utils/languageValue';

interface IMemeLangDistributionProps {
  filter: any;
  /** Compact mode for drawer: no subtitle, smaller loading height */
  compact?: boolean;
  /** Override data externally — skips internal hook */
  externalData?: any;
  externalLoading?: boolean;
}

export default function MemeLangDistribution(
  props: IMemeLangDistributionProps,
) {
  const { filter, compact = false, externalData, externalLoading } = props;
  const { intl } = useIntls();

  const langFilter = useMemo(() => {
    return {
      ...filter,
    };
  }, [filter]);

  const useInternalData = externalData === undefined;
  const { loading: hookLoading, data: hookData } = useMemeLangDistribution({
    filter: useInternalData ? langFilter : undefined,
  });

  const loading = useInternalData ? hookLoading : externalLoading ?? false;
  const data = useInternalData ? hookData : externalData;

  const loadingHeight = compact ? 130 : 417;

  return (
    <CardCommon
      loading={loading}
      loadingHeight={loadingHeight}
      emptyHeight={loadingHeight}
      className="dbom-meme-lang-distribution"
      title={intl('Language Distribution')}
      contentCard={compact}
    >
      <div className="dbom-meme-lang-sub-title">
        {intl({
          id: 'Language distribution is calculated using all videos entering the all-time Top 500 within the selected period.',
        })}
      </div>
      <DistributionProgress
        data={data?.views_dist}
        valueKey="value"
        title="Views (Top 5)"
        labelKey="language"
        renderLabel={(label) => dealWithOthersName(label, 'language')}
      />
      <DistributionProgress
        data={data?.videos_dist}
        valueKey="value"
        title="Videos (Top 5)"
        labelKey="language"
        renderLabel={(label) => dealWithOthersName(label, 'language')}
      />
    </CardCommon>
  );
}
